export default __webpack_public_path__ + "static/media/medicine-box.2fab746b.svg";